import React from 'react';

// Kleine, originalgetreue Vorschau der 5 E-Mail-Layouts.
// Spiegelt die echten Themes aus email_service._wrap_email_html wider:
//   bold = dunkel, standard = Akzent-Streifen oben, modern = Akzent-Kopf,
//   elegant = Serif + Akzent-Trennlinie (creme), minimal = schlicht/links.
const THEMES = {
  bold: { page: '#0a0a0a', card: '#0a0a0a', text: '#ffffff', muted: '#6b7280', bar: '#262626' },
  standard: { page: '#f3f4f6', card: '#ffffff', text: '#18181b', muted: '#d1d5db', bar: '#e5e7eb' },
  modern: { page: '#eef2f7', card: '#ffffff', text: '#111827', muted: '#d1d5db', bar: '#e5e7eb' },
  elegant: { page: '#faf9f7', card: '#ffffff', text: '#1f2937', muted: '#e5e1da', bar: '#ece9e4' },
  minimal: { page: '#ffffff', card: '#ffffff', text: '#111827', muted: '#e5e7eb', bar: '#f1f1f1' },
};

const Line = ({ w, color }) => (
  <div style={{ height: 4, width: w, borderRadius: 9999, background: color }} />
);

const EmailLayoutThumbnail = ({ layoutId = 'bold', accent = '#22c55e', className = '' }) => {
  const th = THEMES[layoutId] || THEMES.bold;
  const serif = layoutId === 'elegant';

  // Header je Layout
  let header;
  if (layoutId === 'modern') {
    header = (
      <div style={{ background: accent, padding: '7px 0', display: 'flex', justifyContent: 'center' }}>
        <div style={{ height: 7, width: 34, borderRadius: 3, background: 'rgba(255,255,255,0.85)' }} />
      </div>
    );
  } else if (layoutId === 'standard') {
    header = (
      <div>
        <div style={{ height: 4, background: accent }} />
        <div style={{ padding: '8px 0 6px', display: 'flex', justifyContent: 'center' }}>
          <div style={{ height: 7, width: 34, borderRadius: 3, background: '#9ca3af' }} />
        </div>
      </div>
    );
  } else if (layoutId === 'elegant') {
    header = (
      <div style={{ padding: '9px 0 7px', display: 'flex', justifyContent: 'center', borderBottom: `1px solid ${accent}` }}>
        <div style={{ height: 8, width: 40, borderRadius: 2, background: '#b7a98f' }} />
      </div>
    );
  } else if (layoutId === 'minimal') {
    header = (
      <div style={{ padding: '8px 0 4px 10px', display: 'flex', justifyContent: 'flex-start' }}>
        <div style={{ height: 6, width: 26, borderRadius: 2, background: '#9ca3af' }} />
      </div>
    );
  } else {
    // bold (dunkel), zentriertes Logo
    header = (
      <div style={{ padding: '10px 0 6px', display: 'flex', justifyContent: 'center' }}>
        <div style={{ height: 8, width: 38, borderRadius: 3, background: '#4b5563' }} />
      </div>
    );
  }

  const centered = layoutId !== 'minimal';

  return (
    <div
      className={className}
      style={{ background: th.page, borderRadius: 8, padding: layoutId === 'minimal' ? 0 : 6, overflow: 'hidden' }}
      data-testid={`email-layout-thumb-${layoutId}`}
    >
      <div style={{ background: th.card, borderRadius: 6, overflow: 'hidden', border: layoutId === 'bold' ? '1px solid #1f1f1f' : '1px solid #f1f1f1' }}>
        {header}
        <div style={{ padding: layoutId === 'minimal' ? '2px 10px 10px' : '4px 12px 12px', display: 'flex', flexDirection: 'column', gap: 5, alignItems: centered ? 'center' : 'flex-start' }}>
          {/* Überschrift (Serif-Andeutung bei elegant via Breite/Farbe) */}
          <div style={{ height: serif ? 6 : 6, width: '55%', borderRadius: 3, background: th.text, opacity: layoutId === 'bold' ? 0.95 : 0.85 }} />
          <Line w={'100%'} color={th.muted} />
          <Line w={'90%'} color={th.muted} />
          <Line w={'70%'} color={th.muted} />
          {/* Button */}
          <div style={{ marginTop: 3, height: 9, width: 40, borderRadius: 9999, background: accent }} />
        </div>
      </div>
    </div>
  );
};

export default EmailLayoutThumbnail;
